export class SurveyUser {

  public username: string;
  public first_name: string;
  public last_name: string;
  public email: string;
}

